/**
 * @description: 常量定义
 * @author: lantf
 * @date: 2020/10/18 15:27
 */

export const kPlayVideoReq = 0;
export const kPauseVideoReq = 1;
export const kStopVideoReq = 2;

export const kMediaVideo = 0;
export const kMediaAudio = 1;
export const kMediaSpeak = 2;

export const kDecoderH264 = 0;
export const kDecoderH265 = 1;

export const kProtoHttp = 0;
export const kProtoWebsocket = 1;

export const kOpenDecoderReq = 1;
export const kCloseDecoderReq = 2;
export const kResumeDecodingReq = 3;
export const kPauseDecodingReq = 4;
export const kOpenStreamReq = 5;
export const kCloseStreamReq = 6;
export const kEnableAudioReq = 7;
export const kRecorderStreamReq = 8;
export const kSwitchStreamReq = 9;
export const kFastForward = 10;
export const kRecorderSpeakReq = 11;
export const kRecorderTalkReq = 12;
export const kReplayReq = 13;
export const kVideoAudioOffset = 14;
export const kReplaySpeedReq = 15;
export const kChangeRenderTypeReq = 16;

export const kInitDecoderRsp = 0;
export const kUninitDecoderRsp = 1;
export const kOpenDecoderRsp = 2;
export const kCloseDecoderRsp = 3;
export const kVideoReady = 4;
export const kVideoFrame = 5;
export const kAudioFrame = 6;
export const kStringFrame = 7;
export const kNetSpeedFrame = 8;
export const kPauseDecodingRsp = 9;
export const kDecodeFinishedEvt = 10;
export const kSocketOpenRsp = 11;
export const kSocketTimeoutRsp = 12;
export const kSocketErrorRsp = 13;
export const kSocketCloseRsp = 14;
export const kVideoFrameOriginRsp = 16;
export const kFlushAudio = 17;
export const kNoCache = 18;
export const kCacheAvailable = 19;



export class Logger {
  constructor(module) {
    this.module = module;
  }

  log(line) {
    console.log("[" + this.currentTimeStr() + "][" + this.module + "]" + line);
  }

  logError(line) {
    console.log(
      "[" + this.currentTimeStr() + "][" + this.module + "][ER] " + line,
    );
  }

  logInfo(line) {
    console.log(
      "[" + this.currentTimeStr() + "][" + this.module + "][IF] " + line,
    );
  }

  logDebug(line) {
    console.log(
      "[" + this.currentTimeStr() + "][" + this.module + "][DT] " + line,
    );
  }

  currentTimeStr() {
    const now = new Date(Date.now());
    const year = now.getFullYear();
    const month = now.getMonth() + 1;
    const day = now.getDate();
    const hour = now.getHours();
    const min = now.getMinutes();
    const sec = now.getSeconds();
    const ms = now.getMilliseconds();
    return (
      year +
      "-" +
      month +
      "-" +
      day +
      " " +
      hour +
      ":" +
      min +
      ":" +
      sec +
      ":" +
      ms
    );
  }
}

export default {
  kChangeRenderTypeReq,
  kVideoAudioOffset,
  kPlayVideoReq,
  kPauseVideoReq,
  kStopVideoReq,
  kMediaVideo,
  kMediaAudio,
  kMediaSpeak,
  kDecoderH264,
  kDecoderH265,
  kProtoHttp,
  kProtoWebsocket,
  kOpenDecoderReq,
  kCloseDecoderReq,
  kResumeDecodingReq,
  kPauseDecodingReq,
  kOpenStreamReq,
  kCloseStreamReq,
  kEnableAudioReq,
  kRecorderStreamReq,
  kSwitchStreamReq,
  kFastForward,
  kRecorderSpeakReq,
  kRecorderTalkReq,
  kReplayReq,
  kInitDecoderRsp,
  kUninitDecoderRsp,
  kOpenDecoderRsp,
  kCloseDecoderRsp,
  kVideoReady,
  kVideoFrame,
  kAudioFrame,
  kStringFrame,
  kNetSpeedFrame,
  kPauseDecodingRsp,
  kDecodeFinishedEvt,
  kSocketOpenRsp,
  kSocketTimeoutRsp,
  kSocketErrorRsp,
  kSocketCloseRsp,
  kReplaySpeedReq,
  kVideoFrameOriginRsp,
  Logger,
  kFlushAudio,
  kNoCache,
  kCacheAvailable,
};
